import ForgotPasswordHeader from './ForgotPasswordHeader';

export default ForgotPasswordHeader;
